/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'accounting_period': 'Rechnungsperiode',
    'all_expenes_captured': 'Alle Ausgaben wurden erfasst',
    'back_to_expense_dashboard': 'Zurück zur Übersicht',
    'capture_expense': 'Ausgabe erfassen',
    'capture_expenses_heading': 'Ausgaben erfassen',
    'capture_x_expenses_btn': '{count} Ausgaben erfassen',
    'captured_expenses': 'Erfasste Ausgaben',
    'delete_expense_dialog_body': 'Soll die Ausgabe wirklich gelöscht werden? Dies kann nicht rückgängig gemacht werden.',
    'delete_expense_dialog_title': 'Ausgabe löschen',
    'document_upload_invalid_file_type': 'Die Datei {fileName} ist von einem ungültigen Typ',
    'document_upload_successfull': 'Dateien erfolgreich hochgeladen',
    'document_upload_unsuccessfull': 'Einige Dateien konnten nicht hochgeladen werden',
    'due_to_without_cash_discount': 'Fällig ohne Skonto bis',
    'expense': 'Ausgabe|Ausgaben',
    'expense_captured_success': 'Ausgabe erfasst',
    'expense_committed_success': 'Ausgabe erfolgreich festgeschrieben',
    'expense_convert_currency': 'Ausgaben in Fremdwährungen müssen in Euro umgerechnet werden',
    'expense_created': 'Ausgabe erstellt',
    'expense_data_heading': 'Belegdaten',
    'expense_deleted_success': 'Ausgabe erfolgreich gelöscht',
    'expense_delivery_date': 'Leistungsdatum',
    'expense_due_to': 'Fällig bis {date}',
    'expense_export_modal_body': 'Die Ausgaben können mit den untenstehenden Optionen gefiltert werden. Sollen alle Ausgaben exportiert werden, <br>klicke einfach auf "Exportieren".',
    'expense_export_modal_title': 'Ausgaben exportieren',
    'expense_filter_invoice_date_from': 'Rechnungsdatum von',
    'expense_filter_invoice_date_to': 'Rechnungsdatum bis',
    'expense_filter_not_paid_only': 'Nicht bezahlt',
    'expense_filter_paid_only': 'Bezahlt',
    'expense_filter_payment': 'Zahlungstand',
    'expense_no_due_date': 'Kein Fälligkeitsdatum',
    'expense_not_yet_paid': 'Noch nicht bezahlt',
    'expense_paid_at': 'Bezahlt am',
    'expense_paid_at_line': 'Bezahlt am {date}',
    'expense_saved_success': 'Ausgabe gespeichert',
    'expense_supplier': 'Geschäftspartner',
    'expenses_statistics_overview_heading': 'Ausgabenübersicht',
    'no_expenses': 'Keine Ausgaben verfügbar',
    'no_expenses_to_capture': 'Alle Ausgaben erfasst',
    'no_recent_expenses_available': 'Keine kürzlichen Ausgaben vorhanden',
    'payment_terms_heading': 'Zahlungsbedingungen',
    'recent_expenses_heading': 'Kürzliche Ausgaben',
    'show_all_expenses': 'Alle Ausgaben',
    'uncaptured_expenses_heading': 'Noch nicht erfasste Ausgaben',
    'upload_document_dropzone_text': 'Dateien ablegen oder klicken zum hochladen.'
  },

  /* english */
  en: {
    'accounting_period': 'Accounting Period',
    'all_expenes_captured': 'All expenes are captured',
    'back_to_expense_dashboard': 'Backt to expense dashboard',
    'capture_expense': 'Capture Expense',
    'capture_expenses_heading': 'Capture Expenses',
    'capture_x_expenses_btn': 'Capture {count} expenses',
    'captured_expenses': 'Captured Expenses',
    'delete_expense_dialog_body': 'Do you really want to delete the expense? This can not be undone.',
    'delete_expense_dialog_title': 'Delete Expense',
    'document_upload_invalid_file_type': 'The file {fileName} is of an invalid type',
    'document_upload_successfull': 'Files uploaded sucessfully',
    'doucment_upload_unsuccessfull': 'Some files could not be uploaded',
    'due_to_without_cash_discount': 'Due without cash discount to',
    'expense': 'Expense|Expenses',
    'expense_captured_success': 'Expense captured',
    'expense_committed_success': 'Expense committed successfully',
    'expense_convert_currency': 'Expenses in foreign currencies have to be converted to Euro',
    'expense_created': 'Expense created',
    'expense_data_heading': 'Expense Data',
    'expense_deleted_success': 'Expense deleted successfully',
    'expense_delivery_date': 'Date of service',
    'expense_due_to': 'Due to {date}',
    'expense_export_modal_body': 'You can filter the export if you wish. If you like to export all expenses,<br>just click "Export".',
    'expense_export_modal_title': 'Export expenses',
    'expense_filter_invoice_date_from': 'Invoice date from',
    'expense_filter_invoice_date_to': 'Invoice date to',
    'expense_filter_not_paid_only': 'Not paid',
    'expense_filter_paid_only': 'Paid',
    'expense_filter_payment': 'Payment status',
    'expense_no_due_date': 'No due date',
    'expense_not_yet_paid': 'Not yet paid',
    'expense_paid_at': 'Paid at',
    'expense_paid_at_line': 'Paid at {date}',
    'expense_saved_success': 'Expense saved',
    'expense_supplier': 'Business Associate',
    'expenses_statistics_overview_heading': 'Expense Overview',
    'no_expenses': 'No expenses available',
    'no_expenses_to_capture': 'All expenses captured',
    'no_recent_expenses_available': 'No recent expenses available',
    'payment_terms_heading': 'Payment Terms',
    'recent_expenses_heading': 'Recent Expenses',
    'show_all_expenses': 'All Expenses',
    'uncaptured_expenses_heading': 'Not captured expenses',
    'upload_document_dropzone_text': 'Drop files or click to upload.'
  }
}
